<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Nova Empresa</h5>
                <hr>                
                <Panel header="Informações gerais" class="p-mt-3 p-mb-3">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-6 p-md-6">
                            <label for="razaoSocial">Razão social</label>
                            <InputText id="razaoSocial" type="text" v-model.trim="cnpj.razaoSocial" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !cnpj.razaoSocial">Informe a Razão social</small>
                        </div>
                        <div class="p-field p-col-6 p-md-6">
                            <label for="nomeFantasia">Nome Fantasia</label>
                            <InputText id="nomeFantasia" type="text" v-model.trim="empresa.nomeFantasia" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !empresa.nomeFantasia">Informe o Nome Fantasia</small>
                        </div>
                        <div class="p-field p-col-2 p-md-2">
                            <label>Documento</label>                           
                            <Dropdown v-model="cnpj.tipoNumeroDocumento" :options="tiposDocumentosEmpresa" required="true"
								optionLabel="nome" optionValue="valor" placeholder="Selecione" @change="formatarDocumento()"/>
							<small class="p-invalid" v-if="enviandoForm && !cnpj.tipoNumeroDocumento">Selecione o tipo de documento da empresa</small>
                        </div>
                        <div class="p-field p-col-2 p-md-2">
                            <label for="cnpj">{{ cnpj.tipoNumeroDocumento == 'cnpj' ? 'CNPJ' : 'CPF' }}</label>
                            <InputText v-model="cnpj.numero" @keyup="formatarDocumento($event)"
                            required="true" autocomplete="off" maxlength="18" v-if="cnpj.tipoNumeroDocumento == 'cnpj'"/>
                            <InputText v-model="cnpj.numero" @keyup="formatarDocumento($event)"
                            required="true" autocomplete="off" maxlength="14" v-else/>   
                            <small class="p-invalid" v-if="enviandoForm && !cnpj.numero">Informe o cnpj</small>
                        </div>
                        <div class="p-field p-col-2 p-md-2">
                            <label for="codigoContabil">Código contábil</label>
                            <InputText id="codigoContabil" v-model.trim="empresa.codigoContabil" autocomplete="off" maxlength="15"/>
                        </div>
                        <div class="p-field p-col-2 p-md-2">
                            <label for="codigoFilial">Código da filial</label>
                            <InputText id="codigoFilial" v-model.trim="empresa.codigoFilial" autocomplete="off" maxlength="15"/>
                        </div>      
                        <div class="p-field p-col-3 p-md-2">
                            <label>Celular</label>
                            <InputMask mask="(99) 99999-9999" v-model="cnpj.celular" placeholder="(  ) _____-____" autocomplete="off" />                            
                        </div>                  
                        <div class="p-field p-col-3 p-md-2">
                            <label for="tel1">Telefone 1</label>
                            <InputMask id="tel1" mask="(99) 9999-9999" v-model="cnpj.telefone1" placeholder="(  ) ____-____" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !cnpj.telefone1">Informe o Telefone</small>
                        </div>
                        <div class="p-field p-col-3 p-md-2">
                            <label for="tel2">Telefone 2</label>
                            <InputMask id="tel2" mask="(99) 9999-9999" v-model="cnpj.telefone2" placeholder="(  ) ____-____" autocomplete="off" />
                        </div>                         
                        <div class="p-field p-col-2 p-md-2">
                            <label for="tipoLocal">Tipo de seguimento</label>                           
                            <Dropdown id="tipoLocal" v-model="empresa.seguimento" :options="tiposSeguimentos" required="true"
								optionLabel="nome" optionValue="valor" placeholder="Selecione"/>
							<small class="p-invalid" v-if="enviandoForm && !empresa.seguimento">Selecione um tipo de seguimento</small>
                        </div>
                        <div class="p-field p-col-12 p-md-4">
							<label for="dataContratoCliente">Assinatuara do Contrato</label>
							<Calendar id="dataContratoCliente" v-model="empresa.dataContratoCliente" :showIcon="true" 
                            :manualInput="false" required="true" dateFormat="dd/mm/yy"/>
                            <small class="p-invalid" v-if="enviandoForm && !empresa.dataContratoCliente">Informe a data Inicio do Contrato</small>								
						</div>
                    </div>
                </Panel>
                <Panel header="Endereço" class="p-mt-3 p-mb-3">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-2 p-md-2">
                            <label for="tipoLocal">Tipo de local</label>                           
                            <Dropdown id="tipoLocal" v-model="endereco.tipoLocal" :options="tiposLocais" required="true"
								optionLabel="nome" optionValue="valor" placeholder="Selecione"/>
							<small class="p-invalid" v-if="enviandoForm && !endereco.tipoLocal">Selecione um tipo de local</small>
                        </div>
                        <div class="p-field p-col-8 p-md-8">
                            <label for="descricao">Descrição</label>
                            <InputText id="descricao" v-model.trim="endereco.rua" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !endereco.rua">Informe a descrição</small>
                        </div>
                        <div class="p-field p-col-2 p-md-2">
                            <label for="numero">Número</label>
                            <InputText id="numero" type="text" v-model.trim="endereco.numero" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !endereco.numero">Informe o número</small>
                        </div>
                        <div class="p-field p-col-3 p-md-3">
                            <label for="cep">CEP</label>
                            <InputMask mask="99-999-999" id="cep" v-model="endereco.cep" placeholder="__-___-___" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !endereco.cep">Informe o cep</small>
                        </div>
                        <div class="p-field p-col-9 p-md-9">
                            <label for="bairro">Bairro</label>
                            <InputText id="bairro" v-model.trim="endereco.bairro" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !endereco.bairro">Informe o bairro</small>
                        </div> 
                        <div class="p-field p-col-6 p-md-6">
                            <label for="complemento">Complemento</label>
                            <InputText id="complemento" v-model.trim="endereco.complemento" autocomplete="off" />
                        </div> 
                        <div class="p-field p-col-3 p-md-3">
                            <label for="estadp">Estado</label>                            
                            <Dropdown id="estado" @change="listarCidades" v-model="idEstadoSelecionado" :options="estados" optionLabel="uf" optionValue="id" 
                                placeholder="Selecione" :filter="true" :showClear="true"/>					
                        </div> 
                        <div class="p-field p-col-3 p-md-3">
                            <label for="cidade">Cidade</label>                           
                            <Dropdown id="cidade" v-model="endereco.cidade" :options="cidades" required="true"
								optionLabel="nome" placeholder="Selecione" :filter="true" :showClear="true"/>
							<small class="p-invalid" v-if="enviandoForm && !endereco.cidade.id">Selecione uma cidade</small>
                        </div> 
                    </div>
                </Panel>
                <Panel header="Usuário administrador da conta" class="p-mt-3">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-6">
                            <label for="nomeUsuario">Nome</label>
                            <InputText id="nomeUsuario" v-model="usuario.nome" required="true" autocomplete="off" maxlength="50"/>
                            <small class="p-invalid" v-if="enviandoForm && !usuario.nome">Informe o nome</small>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <label>E-mail</label>
                            <InputText v-model="usuario.email" autocomplete="off" maxlength="50"/>							
                        </div>
                    </div>
                </Panel>                
                <FormPlano ref="formPlano" />
                <Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="cancelar"/>
                <Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="salvar"/>
            </div>
        </div>
    </div>
</template>

<script>
import FormPlano from '@/components/pages/cadastro/cliente/FormPlano';
import Cnpj from '@/model/Cnpj';
import Endereco from '@/model/Endereco';
import PlanoService from '@/service/PlanoService';
import EmpresaService from '@/service/EmpresaService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    planoService: null,
    empresaService: null,
    data() {
        return {
            idEstadoSelecionado: null,
            enviandoForm: false,
            cidades: [],
            estados: [],
            planos: [] ,
            tiposLocais: [],
            tiposSeguimentos: [],
            cnpj: new Cnpj(),
            endereco: new Endereco(),
            empresa: {},
            usuario: {
                email: '',
                nome: ''
            },       
            tiposDocumentosEmpresa: [{nome:'CNPJ', valor: 'cnpj'}, {nome:'CPF', valor: 'cpf'}],     
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        salvar() {            
            this.enviandoForm = true;            
            if(this.cnpj.numero == '' || this.cnpj.razaoSocial == '' || this.empresa.nomeFantasia == '' 
                || this.empresa.dataContratoCliente == '' || this.cnpj.telefone1 == ''
                || this.endereco.tipoLocal == '' || this.endereco.rua == '' || this.endereco.numero == ''
                || this.endereco.cep == '' || this.endereco.bairro == '' || this.endereco.cidade.id == null) {  
                return;                            
            }           
            this.$refs.formPlano.validarCampos(this.enviandoForm);           
            let planoSelecionado = this.$refs.formPlano.getPlano();
            if(planoSelecionado.nome == '' || planoSelecionado.quantidadePessoas == null 
                || planoSelecionado.quantidadePessoas <= 0
                || (planoSelecionado.tipoPagamento == 1 && 
                    (planoSelecionado.valorMensal == null || planoSelecionado.valorMensal <= 0))
                || (planoSelecionado.tipoPagamento == 2 && 
                    (planoSelecionado.valorAnual == null || planoSelecionado.valorAnual <= 0))) {
                return;
            }           
            const emp = {...this.empresa};
            emp.dataContratoCliente = this.empresa.dataContratoCliente.toISOString().substring(0, 10);
            let requisicao = {
                cnpj: {...this.cnpj},
                endereco: {...this.endereco},
                empresa: emp,
                usuario: {...this.usuario},
                plano: planoSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.empresaService.salvar(requisicao)
                .then(resp => {
                    if(this.id == null) {
                        this.cnpj = new Cnpj();
                        this.endereco = new Endereco();
                        this.empresa = {};
                    }                        
                    this.enviandoForm = false;                        
                    exibirMensagem(this, resp);                                               
                })
                .catch(erro => {
                    this.enviandoForm = false;
                    exibirMensagem(this, erro);
                }); 
        },
        listarEstados() {
            this.empresaService.listarEstados()
				.then(resp => {					
					this.estados = resp.data;					
				})
				.catch(erro => {exibirMensagem(this, erro)});
        },
        listarCidades() {
            if(this.idEstadoSelecionado == null) {
				this.cidades = [];
			} else {
				this.empresaService.listarCidades(this.idEstadoSelecionado)
					.then(resp => {					
						this.cidades = resp.data;
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}
        },
        carregarTiposLocais() {
            this.tiposLocais.push({nome: "Rua", valor: "Rua"});
            this.tiposLocais.push({nome: "Avenida", valor: "Avenida"});
            this.tiposLocais.push({nome: "Alamenda", valor: "Alamenda"});
            this.tiposLocais.push({nome: "Travessa", valor: "Travessa"});
            this.tiposLocais.push({nome: "Largo", valor: "Largo"});
            this.tiposLocais.push({nome: "Praia", valor: "Praia"});
        },
        carregarTiposSeguimentos() {
            this.tiposSeguimentos.push({nome: "Bares e restaurantes", valor: "Bares e restaurantes"});
            this.tiposSeguimentos.push({nome: "Construção civil", valor: "Construção civil"});
            this.tiposSeguimentos.push({nome: "Condomínios e Hostéis", valor: "Condomínios e Hostéis"});
            this.tiposSeguimentos.push({nome: "Grandes empresas e órgãos públicos", valor: "Grandes empresas e órgãos públicos"});
            this.tiposSeguimentos.push({nome: "Instituições de ensino", valor: "Instituições de ensino"});
            this.tiposSeguimentos.push({nome: "Pequenas e médias empresas", valor: "Pequenas e médias empresas"});
            this.tiposSeguimentos.push({nome: "Saúde", valor: "Saúde"});
            this.tiposSeguimentos.push({nome: "Varejo", valor: "Varejo"});
            this.tiposSeguimentos.push({nome: "Outros", valor: "Outros"});
        },
        listarPlanos() {
            let requisicao = {                   
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.planoService.listarAtivos(requisicao)
				.then(resp => {		
                    this.$refs.formPlano.carregar(resp.data);									
				})
				.catch(erro => {exibirMensagem(this, erro)});
        }, 
        /**
         * 
         */
        formatarDocumento(event) {
            if(event && (event.keyCode == 8 || event.keyCode == 46)) {
                return;
            }
            let numeros = this.cnpj.numero.replace(/\D/g, '').split('');        
            let valor = '';    
            if(this.cnpj.tipoNumeroDocumento == 'cnpj') {          
                numeros.forEach((num)=> {
                    valor += ''+
                    num;
                    if(valor.length == 2 || valor.length == 6) {
                        valor += '.';
                    } else if(valor.length == 10) {
                        valor += '/';
                    } else if(valor.length == 15) {
                        valor += '-';
                    }
                });
            } else {// cpf             
                numeros.forEach((num)=> {
                    valor += ''+num;
                    if(valor.length == 3 || valor.length == 7) {
                        valor += '.';
                    } else if(valor.length == 11) {
                        valor += '-';
                    }
                });
            }
            this.cnpj.numero = valor;
        },          
        cancelar() {
            this.$router.push('/cadastro/clientes/ikponto');
        }
    },
    created() {
        this.planoService = new PlanoService();
        this.empresaService = new EmpresaService();
    },
    mounted() {       
        this.listarPlanos();
        this.carregarTiposSeguimentos();
        this.carregarTiposLocais();
        this.listarEstados();
    },
    components: {
        'FormPlano': FormPlano,
    }
}
</script>

<style>

</style>